// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__ISFIA","modal":"Modal_modal__hF9lv","top":"Modal_top__Wy2Qc","title":"Modal_title__gL9Vk","close":"Modal_close__Wxtmt","body":"Modal_body__UcF0x"};